import React from 'react';

type ButtonVariant = 'primary' | 'secondary' | 'outline' | 'ghost';
type ButtonSize = 'sm' | 'base' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  size = 'base',
  children,
  className = '',
  disabled,
  ...props
}) => {
  const baseStyles = 'font-sans font-semibold rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2';
  
  const variants = {
    primary: 'bg-green-600 text-white hover:bg-green-900 focus:ring-green-600',
    secondary: 'bg-blue-600 text-white hover:bg-blue-900 focus:ring-blue-600',
    outline: 'bg-white border-2 border-green-600 text-green-600 hover:bg-green-600 hover:text-white focus:ring-green-600',
    ghost: 'text-grey-600 hover:text-black hover:bg-grey-100 focus:ring-grey-600',
  };
  
  const sizes = {
    sm: 'py-2 px-4 text-sm',
    base: 'py-3 px-6 text-base',
    lg: 'py-4 px-8 text-lg',
  };
  
  const disabledStyles = disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer';
  
  return (
    <button
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${disabledStyles} ${className}`}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;
export { Button }; 